function helperNumberDecimal (numStr) {
  return (numStr.split('.')[1] || '').length
}

module.exports = helperNumberDecimal



//////////////////
// WEBPACK FOOTER
// ./~/xe-utils/helperNumberDecimal.js
// module id = dC0T
// module chunks = 137